import React from "react";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";
import { green, orange, red, blue } from "@mui/material/colors";
import { ACTION_PERMISSIONS } from "../services/Enums";
import { usePermissions } from "../services/PermissionsContext";

// Mapping button types to colors and styles
const BUTTON_STYLES = {
  create: { label: "Create", style: { backgroundColor: green[500], color: "#fff" } },
  update: { label: "Update", style: { backgroundColor: orange[500], color: "#fff" } },
  delete: { label: "Delete", style: { backgroundColor: red[500], color: "#fff" } },
  display: { label: "Display", style: { backgroundColor: blue[500], color: "#fff" } },
};

// Mapping between ACTION_PERMISSIONS and permission keys


// Utility function to check permissions
const checkPermission = (permissions, action) => {
  // Check if the action is provided
  if (!action) {
  //  console.warn("No action provided.");
    return true;
  }

  // Ensure action is a string
  const permissionPath = typeof action === 'string' ? action : null;

  // If action is not a string, log a warning and return false
  if (!permissionPath) {
    console.warn("Invalid action passed:", action);
    return false;
  }

  // Split the path and traverse the permissions object
  const keys = permissionPath.split(".");
  let result = permissions;
  for (const key of keys) {
    result = result?.[key];
    if (result === undefined) {
      return false;
    }
  }
  return result;
};



const MyButton = ({ type = "create", action, onClick, children, disabled = false, ...props }) => {
  const { permissions } = usePermissions(); // Ensure `permissions` is defined

  // If no action is set, allow the button to be enabled
  if (!action) {
   // console.warn("No action provided to MyButton. Defaulting to enabled.");
  }

  // Check the permissions based on the action
  const hasPermission = checkPermission(permissions, action);

  const handleClick = (event) => {
    
    if (!hasPermission) {
      alert(`Vous ne disposez pas des permissions nécessaires pour effectuer cette action.`);
      return;
    }
    if (onClick) {
      onClick(event);
    }
  };

  const { label, style } = BUTTON_STYLES[type] || BUTTON_STYLES.create;

  return (
    <Button
      variant="contained"
      onClick={handleClick}
      sx={{ ...style, borderRadius: "8px" }}
      disabled={disabled}
      {...props}
    >
      {children || label}
    </Button>
  );
};

MyButton.propTypes = {
  type: PropTypes.oneOf(Object.keys(BUTTON_STYLES)),
  action: PropTypes.oneOf(Object.values(ACTION_PERMISSIONS)), // Accept permission values
  onClick: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

export default MyButton;